import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Check } from "lucide-react"

/** Beside a section's Save button once its edits are stored, until the next
 *  edit: the saved state stays on the page, not only in a passing toast. */
export function SavedMark() {
  const { translate } = useTranslation()
  return (
    <span
      role="status"
      className="flex items-center gap-1 text-sm text-muted-foreground"
    >
      <Check aria-hidden className="size-4" />
      {translate("SETTINGS/SAVED_MARK")}
    </span>
  )
}
